// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-line-chart-widget-main-header-container{
    padding: 15px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: white;
    background-color: rgba(155, 30, 30, 0.952);
}
.edit-line-chart-widget-main-header-container h2{
    margin: 4px 0px;
    font-size: 24px;
    font-weight: 600;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.edit-line-chart-widget-main-header-container p{
    margin: 4px 0px;
    font-size: 14px;
}
.edit-line-chart-widget-main-header-container button{
    border: none;
    cursor: pointer;
    border-radius: 50%;
    font-size: 18px;
    margin-left: 20px;
}
.edit-line-chart-widget-main-header-container .help-button{
    padding: 4px 10px;
    color: rgba(155, 30, 30, 0.952);
    background-color: white;
}
.edit-line-chart-widget-main-header-container .close-editor-button{
    color: white;
    background-color: transparent;
    padding: 5px 10px;
    transition: background-color 0.5s ease;
}
.edit-line-chart-widget-main-header-container .close-editor-button:hover{
    background-color: rgba(110, 17, 17, 0.849);
}
.edit-line-chart-widget-minor-header-container{
    padding: 20px 20px;
    padding-bottom: 10px;
    display: flex;
    justify-content: flex-end;
    box-shadow: 0px 2px 2px rgba(145, 145, 145, 0.2);
}
.edit-line-chart-widget-minor-header-container .decline.active{
    pointer-events: auto;
    cursor: pointer;
    border-radius: 4px;
    margin-right: 10px;
    padding: 6px 14px;
    color: rgba(155, 30, 30, 0.952);
    border: 1px solid rgb(194, 194, 194);
    background-color: transparent;
}
.edit-line-chart-widget-minor-header-container .decline.active:hover{
    background-color: rgba(255, 249, 249, 0.952);
}
.edit-line-chart-widget-minor-header-container .decline.inactive{
    border-radius: 4px;
    margin-right: 10px;
    padding: 6px 14px;
    color: rgb(150, 150, 150);
    border: 1px solid rgb(194, 194, 194);
    background-color: transparent;
    pointer-events: none;
}
.edit-line-chart-widget-minor-header-container .apply.active{
    border: none;
    cursor: pointer;
    padding: 7px 16px;
    border-radius: 4px;
    color: white;
    background-color: rgba(155, 30, 30, 0.952);
}
.edit-line-chart-widget-minor-header-container .apply.active:hover{
    background-color: rgba(172, 49, 49, 0.952);
}
.edit-line-chart-widget-minor-header-container .apply.inactive{
    border: none;
    padding: 7px 16px;
    border-radius: 2px;
    background-color: lightgray;
    cursor: default;
}
.edit-line-chart-widget-body-container{
    height: 70vh;
    padding: 15px 20px;
    overflow-y: auto;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.edit-line-chart-widget-body-container::-webkit-scrollbar{
    width: 5px;
}
.edit-line-chart-widget-body-container::-webkit-scrollbar-thumb{
    border-radius: 5px;
    background-color: rgba(0, 0, 0, 0.3);
}


.edit-line-chart-widget-time-window-container{
    padding: 25px;
    border-radius: 4px;
    margin-bottom: 15px;
    box-shadow: 0px 0px 8px rgba(129, 129, 129, 0.15);
}
.edit-line-chart-widget-time-window-container .header{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.edit-line-chart-widget-time-window-container .header h2{
    margin: 0px;
    font-size: 18px;
    font-weight: 500;
}
.edit-line-chart-widget-time-window-container .header div{
    border-radius: 15px;
    background-color: rgb(231, 231, 231);
}
.edit-line-chart-widget-time-window-container .header button{
    border: none;
    cursor: pointer;
    padding: 6px 15px;
    border-radius: 15px;
    color: rgb(134, 134, 134);
    background-color: rgb(231, 231, 231);
}
.edit-line-chart-widget-time-window-container .header button.active{
    color: rgb(0, 128, 0);;
    background-color: white;
    border: 1px solid rgb(0, 128, 0);
}
.edit-line-chart-widget-time-window-container .body{
    position: relative;
    display: flex;
    align-items: center;
    margin-top: 20px;
    padding: 16px 12px;
    border-radius: 5px;
    border: 1px solid rgb(230, 230, 230);
}
.edit-line-chart-widget-time-window-container .body p{
    margin: 0px 16px;
}
.edit-line-chart-widget-time-window-container .inactive-time-window-mask.active{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(255, 255, 255, 0.719);
}
.edit-line-chart-widget-time-window-container .body .time-window-selector-container{
    position: relative;
}
.edit-line-chart-widget-time-window-container .body .show-time-window-selector-button{
    padding: 5px 10px;
    display: flex;
    align-items: center;
    cursor: pointer;
    border-radius: 4px;
    border: 1px solid rgb(168, 168, 168);
    background-color: rgb(248, 248, 248);
    transition: background-color 0.25s ease;
}
.edit-line-chart-widget-time-window-container .body .show-time-window-selector-button:hover{
    background-color: rgb(236, 236, 236);
}
.edit-line-chart-widget-time-window-container .body .show-time-window-selector-button img{
    height: 16px;
    margin-right: 10px;
}


.edit-line-chart-widget-data-source-container{
    padding: 25px;
    border-radius: 4px;
    margin-bottom: 15px;
    box-shadow: 0px 0px 8px rgba(129, 129, 129, 0.15);
}
.edit-line-chart-widget-data-source-container .header{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.edit-line-chart-widget-data-source-container .header h2{
    margin: 0px;
    font-size: 18px;
    font-weight: 500;
}
.edit-line-chart-widget-data-source-container .header div{
    border-radius: 15px;
    background-color: rgb(231, 231, 231);
}
.edit-line-chart-widget-data-source-container .header button{
    border: none;
    cursor: pointer;
    padding: 6px 15px;
    border-radius: 15px;
    color: rgb(134, 134, 134);
    background-color: rgb(231, 231, 231);
}
.edit-line-chart-widget-data-source-container .header button.active{
    color: rgb(0, 128, 0);;
    background-color: white;
    border: 1px solid rgb(0, 128, 0);
}
.edit-line-chart-widget-data-source-container .body .device-selection-container,
.edit-line-chart-widget-data-source-container .body .entity-alias-selection-container{
    position: relative;
    margin: 20px 0px;
    margin-bottom: 0px;
    padding: 4px 10px;
    box-sizing: border-box;
    background-color: rgba(222, 229, 233, 0.6);
    border-bottom: 1px solid rgb(128, 128, 128);
}
.edit-line-chart-widget-data-source-container .body .device-selection-container:focus-within,
.edit-line-chart-widget-data-source-container .body .entity-alias-selection-container:focus-within{
    border-bottom: 1px solid rgba(155, 30, 30, 0.953);
}
.edit-line-chart-widget-data-source-container .body .device-selection-container p,
.edit-line-chart-widget-data-source-container .body .entity-alias-selection-container p{
    margin: 0px;
    font-size: 12px;
    cursor: pointer;
    color: rgb(88, 88, 88);
}
.edit-line-chart-widget-data-source-container .body .device-selection-container span,
.edit-line-chart-widget-data-source-container .body .entity-alias-selection-container span{
    color: red;
}
.edit-line-chart-widget-data-source-container .body .device-selection-container .entry-container,
.edit-line-chart-widget-data-source-container .body .entity-alias-selection-container .entry-container{
    display: flex;
    justify-content: space-between;
}
.edit-line-chart-widget-data-source-container .body .device-selection-container .entry-container input,
.edit-line-chart-widget-data-source-container .body .entity-alias-selection-container .entry-container input{
    flex: 1 1;
    border: none;
    outline: none;
    box-sizing: border-box;
    background-color: transparent;
}
.edit-line-chart-widget-data-source-container .body .device-selection-container .entry-container input.inactive,
.edit-line-chart-widget-data-source-container .body .entity-alias-selection-container .entry-container input.inactive{
    color: gray;
}
.edit-line-chart-widget-data-source-container .body .device-selection-container .entry-container input.active
.edit-line-chart-widget-data-source-container .body .entity-alias-selection-container .entry-container input.active{
    color: rgb(30, 30, 30);
}
.edit-line-chart-widget-data-source-container .body .device-selection-container .entry-container p
.edit-line-chart-widget-data-source-container .body .entity-alias-selection-container .entry-container p{
    margin-right: 10px;
    cursor: pointer;
}
.edit-line-chart-widget-data-source-container .body .device-selection-container .devices-browser,
.edit-line-chart-widget-data-source-container .body .entity-alias-selection-container .entity-alias-browser{
    position: absolute;
    z-index: 1;
    top: 100%;
    max-height: 24vh;
    overflow-y: auto;
    width: 100%;
    display: none;
    margin-top: 2px;
    box-sizing: border-box;
    transform: translateX(-10px);
    background-color: white;
    box-shadow: 0px 0px 8px rgba(80, 80, 80, 0.4);
    border-radius: 0px 0px 4px 4px;
}
.edit-line-chart-widget-data-source-container .body .device-selection-container .devices-browser.active,
.edit-line-chart-widget-data-source-container .body .entity-alias-selection-container .entity-alias-browser.active{
    display: block;
}
.edit-line-chart-widget-data-source-container .body .device-selection-container .devices-browser div,
.edit-line-chart-widget-data-source-container .body .entity-alias-selection-container .entity-alias-browser div{
    padding: 10px 12px;
    cursor: pointer;
    box-sizing: border-box;
    border-bottom: 1px solid rgb(216, 216, 216);
    transition: background-color 0.25s ease;
}
.edit-line-chart-widget-data-source-container .body .device-selection-container .devices-browser div:hover,
.edit-line-chart-widget-data-source-container .body .entity-alias-selection-container .entity-alias-browser div:hover{
    background-color: rgb(236, 236, 236);
}
.edit-line-chart-widget-data-source-container .body .label{
    margin: 0px;
    margin-top: 2px;
    margin-left: 12px;
    color: red;
    font-size: 12px;
}

/*Series section*/
.edit-line-chart-widget-series-container{
    padding: 25px;
    border-radius: 4px;
    margin-bottom: 15px;
    box-shadow: 0px 0px 8px rgba(129, 129, 129, 0.15);
}
.edit-line-chart-widget-series-container h2{
    margin: 0px;
    font-size: 18px;
    font-weight: 500;
}
.edit-line-chart-widget-series-container .body table{
    width: 100%;
    margin: 10px 0px;
    border-radius: 4px;
    table-layout: fixed;
    border-collapse: collapse;
    border: 1px solid rgb(192, 192, 192);
}
.edit-line-chart-widget-series-container .body table th{
    padding: 8px 12px;
    text-align: left;
    font-size: 14px;
    font-weight: 500;
    color: rgb(104, 104, 104);
    border-bottom: 1px solid rgb(192, 192, 192);
}
.edit-line-chart-widget-series-container .body table td{
    padding: 4px 12px;
    padding-top: 10px;
}
.edit-line-chart-widget-series-container .body table .series-key-container{
    position: relative;
    box-sizing: border-box;
}
.edit-line-chart-widget-series-container .body table .series-key-container input{
    width: calc(100% - 5px);
    display: block;
    margin: 0px;
    padding: 4px 5px;
    border: none;
    outline: none;
    color: gray;
    box-sizing: border-box;
    border-bottom: 1px solid rgb(192, 192, 192);
}
.edit-line-chart-widget-series-container .body table .series-key-container input:focus-within{
    border-bottom: 1px solid rgba(155, 30, 30, 0.953);
}
.edit-line-chart-widget-series-container .body table .series-key-container .series-key-entry{
    margin: 5px 0px;
    border-bottom: 1px solid rgb(192, 192, 192);
}
.edit-line-chart-widget-series-container .body table .series-key-container .series-key-entry div{
    margin: 0px 2px;
    margin-bottom: 2px;
    padding: 2px 8px;
    border-radius: 16px;
    display: inline-block;
    text-wrap: nowrap;
    font-size: 14px;
    cursor: default;
    background-color: lightgray;
}
.edit-line-chart-widget-series-container .body table .series-key-container .series-key-entry div .key-icon-container{
    margin: 0px;
    padding: 0px;
}
.edit-line-chart-widget-series-container .body table .series-key-container .series-key-entry div .key-icon{
    display: flex;
    transform: rotate(220deg);
}
.edit-line-chart-widget-series-container .body table .series-key-container .series-key-entry div .key-entry-container{
    display: inline-block;
    margin: 0px;
    padding: 0px;
}
.edit-line-chart-widget-series-container .body table .series-key-container .series-key-entry div .key-entry{
    display: flex;
    max-width: 3.2vw;
    padding: 0px;
    margin: 0px 10px;
    margin-bottom: 2px;
    font-size: 12px;
    text-wrap: nowrap;
    overflow: hidden;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.edit-line-chart-widget-series-container .body table .series-key-container .series-key-entry div .remove-key{
    font-size: 14px;
    cursor: pointer;
}
.edit-line-chart-widget-series-container .body table .series-key-container .series-keys-browser{
    position: absolute;
    z-index: 1;
    top: 100%;
    max-height: 22vh;
    overflow-y: auto;
    max-width: 120%;
    min-width: 100%;
    left: 15px;
    display: none;
    margin-top: 0px;
    box-sizing: border-box;
    transform: translateX(-10px);
    background-color: white;
    box-shadow: 0px 0px 8px rgba(80, 80, 80, 0.4);
    border-radius: 0px 0px 4px 4px;
}
.edit-line-chart-widget-series-container .body table .series-key-container .series-keys-browser.active{
    display: block;
}
.edit-line-chart-widget-series-container .body table .series-key-container .series-keys-browser::-webkit-scrollbar{
    width: 4px;
}
.edit-line-chart-widget-series-container .body table .series-key-container .series-keys-browser::-webkit-scrollbar-thumb{
    border-radius: 10px;
    background-color: rgba(0, 0, 0, 0.3);
}
.edit-line-chart-widget-series-container .body table .series-key-container .series-keys-browser div{
    padding: 10px 12px;
    cursor: pointer;
    white-space: nowrap;
    box-sizing: border-box;
    font-size: 14px;
    overflow-x: hidden;
    border-bottom: 1px solid rgb(216, 216, 216);
    transition: background-color 0.25s ease;
}
.edit-line-chart-widget-series-container .body table .series-key-container .series-keys-browser div:hover{
    background-color: rgb(236, 236, 236);
}
.edit-line-chart-widget-series-container .body table .series-key-container .series-keys-browser div span{
    margin-right: 5px;
    display: inline-block;
    transform: rotate(-145deg);
}
.edit-line-chart-widget-series-container .body table .series-label-container{
    box-sizing: border-box;
}
.edit-line-chart-widget-series-container .body table .series-label-container input{
    width: 100%;
    padding: 4px 10px;
    outline: none;
    border-radius: 4px;
    box-sizing: border-box;
    border: 1px solid rgb(216, 216, 216);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.edit-line-chart-widget-series-container .body table .series-max-value-container,
.edit-line-chart-widget-series-container .body table .series-color-container,
.edit-line-chart-widget-series-container .body table .series-units-container,
.edit-line-chart-widget-series-container .body table .series-decimals-container{
    position: relative;
    box-sizing: border-box;
}
.edit-line-chart-widget-series-container .body table .series-max-value-container input{
    width: 100%;
    padding: 4px 10px;
    border-radius: 4px;
    outline: none;
    box-sizing: border-box;
    border: 1px solid rgb(216, 216, 216);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.edit-line-chart-widget-series-container .body table .series-color-container input{
    width: 25px;
    height: 25px;
    margin: 0px;
    padding: 0px;
    border: none;
    outline: none;
    cursor: pointer;
    box-sizing: border-box;
    background-color: transparent;
}
.edit-line-chart-widget-series-container .body table  .series-units-container input{
    width: 100%;
    padding: 4px 8px;
    border-radius: 4px;
    outline: none;
    box-sizing: border-box;
    color: gray;
    border: 1px solid rgb(216, 216, 216);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.edit-line-chart-widget-series-container .body table  .series-units-container .units-key-entry{
    padding: 4px 8px;
    padding-left: 10px;
    font-size: 14px;
    cursor: default;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid rgb(216, 216, 216);
}
.edit-line-chart-widget-series-container .body table  .series-units-container .units-key-entry .remove-units{
    cursor: pointer;
    font-size: 13px;
    color: rgb(104, 104, 104);
}
.edit-line-chart-widget-series-container .body table  .series-units-container .series-units-browser{
    position: absolute;
    z-index: 1;
    top: 100%;
    max-height: 22vh;
    overflow-y: auto;
    width: 200px;
    left: 20px;
    display: none;
    margin-top: 0px;
    box-sizing: border-box;
    transform: translateX(-10px);
    background-color: white;
    box-shadow: 0px 0px 8px rgba(80, 80, 80, 0.4);
    border-radius: 0px 0px 4px 4px;
}
.edit-line-chart-widget-series-container .body table  .series-units-container .series-units-browser.active{
    display: block;
}
.edit-line-chart-widget-series-container .body table  .series-units-container .series-units-browser div{
    display: flex;
    justify-content: space-between;
    padding: 10px 12px;
    cursor: pointer;
    white-space: nowrap;
    box-sizing: border-box;
    font-size: 13px;
    overflow-x: hidden;
    transition: background-color 0.25s ease;
}
.edit-line-chart-widget-series-container .body table  .series-units-container .series-units-browser div:hover{
    background-color: rgb(236, 236, 236);
}
.edit-line-chart-widget-series-container .body table  .series-units-container .series-units-browser::-webkit-scrollbar{
    width: 4px;
}
.edit-line-chart-widget-series-container .body table  .series-units-container .series-units-browser::-webkit-scrollbar-thumb{
    border-radius: 10px;
    background-color: rgba(0, 0, 0, 0.3);
}
.edit-line-chart-widget-series-container .body table .series-decimals-container input{
    width: 100%;
    padding: 4px 2px;
    padding-left: 8px;
    border-radius: 4px;
    outline: none;
    box-sizing: border-box;
    border: 1px solid rgb(216, 216, 216);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.edit-line-chart-widget-series-container .body table .series-delete-container button{
    border: none;
    cursor: pointer;
    background-color: transparent;
}
.edit-line-chart-widget-series-container .body table .series-delete-container button img{
    height: 20px;
}
.edit-line-chart-widget-series-container .body table .empty-series-container h3{
    margin: 20px 0px;
    margin-bottom: 6px;
    text-align: center;
    font-weight: 400;
    color: rgb(128, 128, 128);
}
.edit-line-chart-widget-series-container .body table .empty-series-container p{
    margin: 0px;
    color: red;
    font-size: 12px;
    text-align: center;
    margin-bottom: 20px;
}
.edit-line-chart-widget-series-container .body .add-series-button{
    margin-top: 10px;
    padding: 8px 12px;
    font-weight: 600;
    border-radius: 4px;
    cursor: pointer;
    color: rgba(155, 30, 30, 0.952);
    background-color: transparent;
    border: 1px solid rgb(212, 212, 212);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    transition: background-color 0.25s ease;
}
.edit-line-chart-widget-series-container .body .add-series-button:hover{
    background-color: rgb(246, 246, 246);
}
.edit-line-chart-widget-series-container .empty-data-source-container h3{
    margin: 20px 0px;
    margin-bottom: 6px;
    text-align: center;
    font-weight: 400;
    color: rgb(128, 128, 128);
}
.edit-line-chart-widget-series-container .empty-data-source-container p{
    margin: 0px;
    color: red;
    font-size: 12px;
    text-align: center;
    margin-bottom: 20px;
}
/*End of series section*/

/*Appearance section*/
.edit-line-chart-widget-appearance-container{
    padding: 25px;
    border-radius: 4px;
    margin-bottom: 15px;
    box-shadow: 0px 0px 8px rgba(129, 129, 129, 0.15);
}
.edit-line-chart-widget-appearance-container h2{
    margin: 0px;
    font-size: 18px;
    font-weight: 500;
}
.edit-line-chart-widget-appearance-container .title-container{
    display: flex;
    align-items: center;
}
.edit-line-chart-widget-appearance-container .body .title-entry-container{
    position: relative;
    width: 50%;
    margin: 20px 0px;
    padding: 4px 10px;
    box-sizing: border-box;
    background-color: rgba(222, 229, 233, 0.6);
    border-bottom: 1px solid rgb(128, 128, 128);
}
.edit-line-chart-widget-appearance-container .body .title-entry-container:focus-within{
    border-bottom: 1px solid rgba(155, 30, 30, 0.953);
}
.edit-line-chart-widget-appearance-container .body .title-entry-container p{
    margin: 0px;
    font-size: 12px;
}
.edit-line-chart-widget-appearance-container .body .title-entry-container input{
    width: 100%;
    border: none;
    outline: none;
    box-sizing: border-box;
    background-color: transparent;
}
.edit-line-chart-widget-appearance-container .body .show-title-container{
    padding-left: 25px;
    display: flex;
    align-items: center;
}
.edit-line-chart-widget-appearance-container .body .show-title-container p{
    margin: 0px;
}
.edit-line-chart-widget-appearance-container .title-color-container{
    position: relative;
    margin: 20px 0px;
    padding: 4px 10px;
    box-sizing: border-box;
    background-color: rgba(222, 229, 233, 0.6);
    border-bottom: 1px solid rgb(128, 128, 128);
}
.edit-line-chart-widget-appearance-container .title-color-container:focus-within{
    border-bottom: 1px solid rgba(155, 30, 30, 0.952);
}
.edit-line-chart-widget-appearance-container .title-color-container p{
    margin: 0px;
    font-size: 12px;
    color: rgb(88, 88, 88);
}
.edit-line-chart-widget-appearance-container .title-color-container div{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.edit-line-chart-widget-appearance-container .title-color-container div p{
    font-size: 14px;
    color: rgb(26, 26, 26);
}
.edit-line-chart-widget-appearance-container .title-color-container div input{
    width: 25px;
    height: 25px;
    margin: 0px;
    padding: 0px;
    border: none;
    outline: none;
    cursor: pointer;
    box-sizing: border-box;
}
.edit-line-chart-widget-appearance-container .border-radius-container,
.edit-line-chart-widget-appearance-container .mobile-height-container{
    position: relative;
    margin: 20px 0px;
    padding: 4px 10px;
    box-sizing: border-box;
    background-color: rgba(222, 229, 233, 0.6);
    border-bottom: 1px solid rgb(128, 128, 128);
}
.edit-line-chart-widget-appearance-container .border-radius-container:focus-within,
.edit-line-chart-widget-appearance-container .mobile-height-container:focus-within{
    border-bottom: 1px solid rgba(155, 30, 30, 0.952);
}
.edit-line-chart-widget-appearance-container .border-radius-container p,
.edit-line-chart-widget-appearance-container .mobile-height-container p{
    margin: 0px;
    font-size: 12px;
    color: rgb(88, 88, 88);
}
.edit-line-chart-widget-appearance-container .border-radius-container div,
.edit-line-chart-widget-appearance-container .mobile-height-container div{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.edit-line-chart-widget-appearance-container .border-radius-container div p,
.edit-line-chart-widget-appearance-container .mobile-height-container div p{
    font-size: 14px;
    color: rgb(26, 26, 26);
}
.edit-line-chart-widget-appearance-container .border-radius-container div input,
.edit-line-chart-widget-appearance-container .mobile-height-container div input{
    width: 25%;
    cursor: pointer;
}
/*End of appearance section*/`, "",{"version":3,"sources":["webpack://./src/styles/Widgets/Charts/EditLineChartWidget.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,0CAA0C;AAC9C;AACA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,4DAA4D;AAChE;AACA;IACI,eAAe;IACf,eAAe;AACnB;AACA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,6BAA6B;IAC7B,iBAAiB;IACjB,sCAAsC;AAC1C;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;IACb,yBAAyB;IACzB,gDAAgD;AACpD;AACA;IACI,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,+BAA+B;IAC/B,oCAAoC;IACpC,6BAA6B;AACjC;AACA;IACI,4CAA4C;AAChD;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,oCAAoC;IACpC,6BAA6B;IAC7B,oBAAoB;AACxB;AACA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,0CAA0C;AAC9C;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,2BAA2B;IAC3B,eAAe;AACnB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,4DAA4D;AAChE;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,oCAAoC;AACxC;;;AAGA;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,iDAAiD;AACrD;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,oCAAoC;AACxC;AACA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,oCAAoC;AACxC;AACA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,gCAAgC;AACpC;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,oCAAoC;AACxC;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,4CAA4C;AAChD;AACA;IACI,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,oCAAoC;IACpC,oCAAoC;IACpC,uCAAuC;AAC3C;AACA;IACI,oCAAoC;AACxC;AACA;IACI,YAAY;IACZ,kBAAkB;AACtB;;;AAGA;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,iDAAiD;AACrD;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,oCAAoC;AACxC;AACA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,oCAAoC;AACxC;AACA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,gCAAgC;AACpC;AACA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,0CAA0C;IAC1C,2CAA2C;AAC/C;AACA;;IAEI,iDAAiD;AACrD;AACA;;IAEI,WAAW;IACX,eAAe;IACf,eAAe;IACf,sBAAsB;AAC1B;AACA;;IAEI,UAAU;AACd;AACA;;IAEI,aAAa;IACb,8BAA8B;AAClC;AACA;;IAEI,SAAO;IACP,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,6BAA6B;AACjC;AACA;;IAEI,WAAW;AACf;AACA;;IAEI,sBAAsB;AAC1B;AACA;;IAEI,kBAAkB;IAClB,eAAe;AACnB;AACA;;IAEI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,4BAA4B;IAC5B,uBAAuB;IACvB,6CAA6C;IAC7C,8BAA8B;AAClC;AACA;;IAEI,cAAc;AAClB;AACA;;IAEI,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,2CAA2C;IAC3C,uCAAuC;AAC3C;AACA;;IAEI,oCAAoC;AACxC;AACA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,UAAU;IACV,eAAe;AACnB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,iDAAiD;AACrD;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,oCAAoC;AACxC;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,2CAA2C;AAC/C;AACA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,sBAAsB;IACtB,2CAA2C;AAC/C;AACA;IACI,iDAAiD;AACrD;AACA;IACI,eAAe;IACf,2CAA2C;AAC/C;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,2BAA2B;AAC/B;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,aAAa;IACb,yBAAyB;AAC7B;AACA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,4DAA4D;AAChE;AACA;IACI,eAAe;IACf,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,UAAU;IACV,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,4BAA4B;IAC5B,uBAAuB;IACvB,6CAA6C;IAC7C,8BAA8B;AAClC;AACA;IACI,cAAc;AAClB;AACA;IACI,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,oCAAoC;AACxC;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,2CAA2C;IAC3C,uCAAuC;AAC3C;AACA;IACI,oCAAoC;AACxC;AACA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,0BAA0B;AAC9B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,oCAAoC;IACpC,4DAA4D;AAChE;AACA;;;;IAII,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,oCAAoC;IACpC,4DAA4D;AAChE;AACA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,6BAA6B;AACjC;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,oCAAoC;IACpC,4DAA4D;AAChE;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,oCAAoC;AACxC;AACA;IACI,eAAe;IACf,eAAe;IACf,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,4BAA4B;IAC5B,uBAAuB;IACvB,6CAA6C;IAC7C,8BAA8B;AAClC;AACA;IACI,cAAc;AAClB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,uCAAuC;AAC3C;AACA;IACI,oCAAoC;AACxC;AACA;IACI,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,oCAAoC;AACxC;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,oCAAoC;IACpC,4DAA4D;AAChE;AACA;IACI,YAAY;IACZ,eAAe;IACf,6BAA6B;AACjC;AACA;IACI,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,+BAA+B;IAC/B,6BAA6B;IAC7B,oCAAoC;IACpC,4DAA4D;IAC5D,uCAAuC;AAC3C;AACA;IACI,oCAAoC;AACxC;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,mBAAmB;AACvB;AACA,wBAAwB;;AAExB,qBAAqB;AACrB;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,iDAAiD;AACrD;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,0CAA0C;IAC1C,2CAA2C;AAC/C;AACA;IACI,iDAAiD;AACrD;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,6BAA6B;AACjC;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,0CAA0C;IAC1C,2CAA2C;AAC/C;AACA;IACI,iDAAiD;AACrD;AACA;IACI,WAAW;IACX,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,eAAe;IACf,sBAAsB;AAC1B;AACA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,0CAA0C;IAC1C,2CAA2C;AAC/C;AACA;;IAEI,iDAAiD;AACrD;AACA;;IAEI,WAAW;IACX,eAAe;IACf,sBAAsB;AAC1B;AACA;;IAEI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;;IAEI,eAAe;IACf,sBAAsB;AAC1B;AACA;;IAEI,UAAU;IACV,eAAe;AACnB;AACA,4BAA4B","sourcesContent":[".edit-line-chart-widget-main-header-container{\n    padding: 15px 20px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    color: white;\n    background-color: rgba(155, 30, 30, 0.952);\n}\n.edit-line-chart-widget-main-header-container h2{\n    margin: 4px 0px;\n    font-size: 24px;\n    font-weight: 600;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n.edit-line-chart-widget-main-header-container p{\n    margin: 4px 0px;\n    font-size: 14px;\n}\n.edit-line-chart-widget-main-header-container button{\n    border: none;\n    cursor: pointer;\n    border-radius: 50%;\n    font-size: 18px;\n    margin-left: 20px;\n}\n.edit-line-chart-widget-main-header-container .help-button{\n    padding: 4px 10px;\n    color: rgba(155, 30, 30, 0.952);\n    background-color: white;\n}\n.edit-line-chart-widget-main-header-container .close-editor-button{\n    color: white;\n    background-color: transparent;\n    padding: 5px 10px;\n    transition: background-color 0.5s ease;\n}\n.edit-line-chart-widget-main-header-container .close-editor-button:hover{\n    background-color: rgba(110, 17, 17, 0.849);\n}\n.edit-line-chart-widget-minor-header-container{\n    padding: 20px 20px;\n    padding-bottom: 10px;\n    display: flex;\n    justify-content: flex-end;\n    box-shadow: 0px 2px 2px rgba(145, 145, 145, 0.2);\n}\n.edit-line-chart-widget-minor-header-container .decline.active{\n    pointer-events: auto;\n    cursor: pointer;\n    border-radius: 4px;\n    margin-right: 10px;\n    padding: 6px 14px;\n    color: rgba(155, 30, 30, 0.952);\n    border: 1px solid rgb(194, 194, 194);\n    background-color: transparent;\n}\n.edit-line-chart-widget-minor-header-container .decline.active:hover{\n    background-color: rgba(255, 249, 249, 0.952);\n}\n.edit-line-chart-widget-minor-header-container .decline.inactive{\n    border-radius: 4px;\n    margin-right: 10px;\n    padding: 6px 14px;\n    color: rgb(150, 150, 150);\n    border: 1px solid rgb(194, 194, 194);\n    background-color: transparent;\n    pointer-events: none;\n}\n.edit-line-chart-widget-minor-header-container .apply.active{\n    border: none;\n    cursor: pointer;\n    padding: 7px 16px;\n    border-radius: 4px;\n    color: white;\n    background-color: rgba(155, 30, 30, 0.952);\n}\n.edit-line-chart-widget-minor-header-container .apply.active:hover{\n    background-color: rgba(172, 49, 49, 0.952);\n}\n.edit-line-chart-widget-minor-header-container .apply.inactive{\n    border: none;\n    padding: 7px 16px;\n    border-radius: 2px;\n    background-color: lightgray;\n    cursor: default;\n}\n.edit-line-chart-widget-body-container{\n    height: 70vh;\n    padding: 15px 20px;\n    overflow-y: auto;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n.edit-line-chart-widget-body-container::-webkit-scrollbar{\n    width: 5px;\n}\n.edit-line-chart-widget-body-container::-webkit-scrollbar-thumb{\n    border-radius: 5px;\n    background-color: rgba(0, 0, 0, 0.3);\n}\n\n\n.edit-line-chart-widget-time-window-container{\n    padding: 25px;\n    border-radius: 4px;\n    margin-bottom: 15px;\n    box-shadow: 0px 0px 8px rgba(129, 129, 129, 0.15);\n}\n.edit-line-chart-widget-time-window-container .header{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n.edit-line-chart-widget-time-window-container .header h2{\n    margin: 0px;\n    font-size: 18px;\n    font-weight: 500;\n}\n.edit-line-chart-widget-time-window-container .header div{\n    border-radius: 15px;\n    background-color: rgb(231, 231, 231);\n}\n.edit-line-chart-widget-time-window-container .header button{\n    border: none;\n    cursor: pointer;\n    padding: 6px 15px;\n    border-radius: 15px;\n    color: rgb(134, 134, 134);\n    background-color: rgb(231, 231, 231);\n}\n.edit-line-chart-widget-time-window-container .header button.active{\n    color: rgb(0, 128, 0);;\n    background-color: white;\n    border: 1px solid rgb(0, 128, 0);\n}\n.edit-line-chart-widget-time-window-container .body{\n    position: relative;\n    display: flex;\n    align-items: center;\n    margin-top: 20px;\n    padding: 16px 12px;\n    border-radius: 5px;\n    border: 1px solid rgb(230, 230, 230);\n}\n.edit-line-chart-widget-time-window-container .body p{\n    margin: 0px 16px;\n}\n.edit-line-chart-widget-time-window-container .inactive-time-window-mask.active{\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background-color: rgba(255, 255, 255, 0.719);\n}\n.edit-line-chart-widget-time-window-container .body .time-window-selector-container{\n    position: relative;\n}\n.edit-line-chart-widget-time-window-container .body .show-time-window-selector-button{\n    padding: 5px 10px;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    border-radius: 4px;\n    border: 1px solid rgb(168, 168, 168);\n    background-color: rgb(248, 248, 248);\n    transition: background-color 0.25s ease;\n}\n.edit-line-chart-widget-time-window-container .body .show-time-window-selector-button:hover{\n    background-color: rgb(236, 236, 236);\n}\n.edit-line-chart-widget-time-window-container .body .show-time-window-selector-button img{\n    height: 16px;\n    margin-right: 10px;\n}\n\n\n.edit-line-chart-widget-data-source-container{\n    padding: 25px;\n    border-radius: 4px;\n    margin-bottom: 15px;\n    box-shadow: 0px 0px 8px rgba(129, 129, 129, 0.15);\n}\n.edit-line-chart-widget-data-source-container .header{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n.edit-line-chart-widget-data-source-container .header h2{\n    margin: 0px;\n    font-size: 18px;\n    font-weight: 500;\n}\n.edit-line-chart-widget-data-source-container .header div{\n    border-radius: 15px;\n    background-color: rgb(231, 231, 231);\n}\n.edit-line-chart-widget-data-source-container .header button{\n    border: none;\n    cursor: pointer;\n    padding: 6px 15px;\n    border-radius: 15px;\n    color: rgb(134, 134, 134);\n    background-color: rgb(231, 231, 231);\n}\n.edit-line-chart-widget-data-source-container .header button.active{\n    color: rgb(0, 128, 0);;\n    background-color: white;\n    border: 1px solid rgb(0, 128, 0);\n}\n.edit-line-chart-widget-data-source-container .body .device-selection-container,\n.edit-line-chart-widget-data-source-container .body .entity-alias-selection-container{\n    position: relative;\n    margin: 20px 0px;\n    margin-bottom: 0px;\n    padding: 4px 10px;\n    box-sizing: border-box;\n    background-color: rgba(222, 229, 233, 0.6);\n    border-bottom: 1px solid rgb(128, 128, 128);\n}\n.edit-line-chart-widget-data-source-container .body .device-selection-container:focus-within,\n.edit-line-chart-widget-data-source-container .body .entity-alias-selection-container:focus-within{\n    border-bottom: 1px solid rgba(155, 30, 30, 0.953);\n}\n.edit-line-chart-widget-data-source-container .body .device-selection-container p,\n.edit-line-chart-widget-data-source-container .body .entity-alias-selection-container p{\n    margin: 0px;\n    font-size: 12px;\n    cursor: pointer;\n    color: rgb(88, 88, 88);\n}\n.edit-line-chart-widget-data-source-container .body .device-selection-container span,\n.edit-line-chart-widget-data-source-container .body .entity-alias-selection-container span{\n    color: red;\n}\n.edit-line-chart-widget-data-source-container .body .device-selection-container .entry-container,\n.edit-line-chart-widget-data-source-container .body .entity-alias-selection-container .entry-container{\n    display: flex;\n    justify-content: space-between;\n}\n.edit-line-chart-widget-data-source-container .body .device-selection-container .entry-container input,\n.edit-line-chart-widget-data-source-container .body .entity-alias-selection-container .entry-container input{\n    flex: 1;\n    border: none;\n    outline: none;\n    box-sizing: border-box;\n    background-color: transparent;\n}\n.edit-line-chart-widget-data-source-container .body .device-selection-container .entry-container input.inactive,\n.edit-line-chart-widget-data-source-container .body .entity-alias-selection-container .entry-container input.inactive{\n    color: gray;\n}\n.edit-line-chart-widget-data-source-container .body .device-selection-container .entry-container input.active\n.edit-line-chart-widget-data-source-container .body .entity-alias-selection-container .entry-container input.active{\n    color: rgb(30, 30, 30);\n}\n.edit-line-chart-widget-data-source-container .body .device-selection-container .entry-container p\n.edit-line-chart-widget-data-source-container .body .entity-alias-selection-container .entry-container p{\n    margin-right: 10px;\n    cursor: pointer;\n}\n.edit-line-chart-widget-data-source-container .body .device-selection-container .devices-browser,\n.edit-line-chart-widget-data-source-container .body .entity-alias-selection-container .entity-alias-browser{\n    position: absolute;\n    z-index: 1;\n    top: 100%;\n    max-height: 24vh;\n    overflow-y: auto;\n    width: 100%;\n    display: none;\n    margin-top: 2px;\n    box-sizing: border-box;\n    transform: translateX(-10px);\n    background-color: white;\n    box-shadow: 0px 0px 8px rgba(80, 80, 80, 0.4);\n    border-radius: 0px 0px 4px 4px;\n}\n.edit-line-chart-widget-data-source-container .body .device-selection-container .devices-browser.active,\n.edit-line-chart-widget-data-source-container .body .entity-alias-selection-container .entity-alias-browser.active{\n    display: block;\n}\n.edit-line-chart-widget-data-source-container .body .device-selection-container .devices-browser div,\n.edit-line-chart-widget-data-source-container .body .entity-alias-selection-container .entity-alias-browser div{\n    padding: 10px 12px;\n    cursor: pointer;\n    box-sizing: border-box;\n    border-bottom: 1px solid rgb(216, 216, 216);\n    transition: background-color 0.25s ease;\n}\n.edit-line-chart-widget-data-source-container .body .device-selection-container .devices-browser div:hover,\n.edit-line-chart-widget-data-source-container .body .entity-alias-selection-container .entity-alias-browser div:hover{\n    background-color: rgb(236, 236, 236);\n}\n.edit-line-chart-widget-data-source-container .body .label{\n    margin: 0px;\n    margin-top: 2px;\n    margin-left: 12px;\n    color: red;\n    font-size: 12px;\n}\n\n/*Series section*/\n.edit-line-chart-widget-series-container{\n    padding: 25px;\n    border-radius: 4px;\n    margin-bottom: 15px;\n    box-shadow: 0px 0px 8px rgba(129, 129, 129, 0.15);\n}\n.edit-line-chart-widget-series-container h2{\n    margin: 0px;\n    font-size: 18px;\n    font-weight: 500;\n}\n.edit-line-chart-widget-series-container .body table{\n    width: 100%;\n    margin: 10px 0px;\n    border-radius: 4px;\n    table-layout: fixed;\n    border-collapse: collapse;\n    border: 1px solid rgb(192, 192, 192);\n}\n.edit-line-chart-widget-series-container .body table th{\n    padding: 8px 12px;\n    text-align: left;\n    font-size: 14px;\n    font-weight: 500;\n    color: rgb(104, 104, 104);\n    border-bottom: 1px solid rgb(192, 192, 192);\n}\n.edit-line-chart-widget-series-container .body table td{\n    padding: 4px 12px;\n    padding-top: 10px;\n}\n.edit-line-chart-widget-series-container .body table .series-key-container{\n    position: relative;\n    box-sizing: border-box;\n}\n.edit-line-chart-widget-series-container .body table .series-key-container input{\n    width: calc(100% - 5px);\n    display: block;\n    margin: 0px;\n    padding: 4px 5px;\n    border: none;\n    outline: none;\n    color: gray;\n    box-sizing: border-box;\n    border-bottom: 1px solid rgb(192, 192, 192);\n}\n.edit-line-chart-widget-series-container .body table .series-key-container input:focus-within{\n    border-bottom: 1px solid rgba(155, 30, 30, 0.953);\n}\n.edit-line-chart-widget-series-container .body table .series-key-container .series-key-entry{\n    margin: 5px 0px;\n    border-bottom: 1px solid rgb(192, 192, 192);\n}\n.edit-line-chart-widget-series-container .body table .series-key-container .series-key-entry div{\n    margin: 0px 2px;\n    margin-bottom: 2px;\n    padding: 2px 8px;\n    border-radius: 16px;\n    display: inline-block;\n    text-wrap: nowrap;\n    font-size: 14px;\n    cursor: default;\n    background-color: lightgray;\n}\n.edit-line-chart-widget-series-container .body table .series-key-container .series-key-entry div .key-icon-container{\n    margin: 0px;\n    padding: 0px;\n}\n.edit-line-chart-widget-series-container .body table .series-key-container .series-key-entry div .key-icon{\n    display: flex;\n    transform: rotate(220deg);\n}\n.edit-line-chart-widget-series-container .body table .series-key-container .series-key-entry div .key-entry-container{\n    display: inline-block;\n    margin: 0px;\n    padding: 0px;\n}\n.edit-line-chart-widget-series-container .body table .series-key-container .series-key-entry div .key-entry{\n    display: flex;\n    max-width: 3.2vw;\n    padding: 0px;\n    margin: 0px 10px;\n    margin-bottom: 2px;\n    font-size: 12px;\n    text-wrap: nowrap;\n    overflow: hidden;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n.edit-line-chart-widget-series-container .body table .series-key-container .series-key-entry div .remove-key{\n    font-size: 14px;\n    cursor: pointer;\n}\n.edit-line-chart-widget-series-container .body table .series-key-container .series-keys-browser{\n    position: absolute;\n    z-index: 1;\n    top: 100%;\n    max-height: 22vh;\n    overflow-y: auto;\n    max-width: 120%;\n    min-width: 100%;\n    left: 15px;\n    display: none;\n    margin-top: 0px;\n    box-sizing: border-box;\n    transform: translateX(-10px);\n    background-color: white;\n    box-shadow: 0px 0px 8px rgba(80, 80, 80, 0.4);\n    border-radius: 0px 0px 4px 4px;\n}\n.edit-line-chart-widget-series-container .body table .series-key-container .series-keys-browser.active{\n    display: block;\n}\n.edit-line-chart-widget-series-container .body table .series-key-container .series-keys-browser::-webkit-scrollbar{\n    width: 4px;\n}\n.edit-line-chart-widget-series-container .body table .series-key-container .series-keys-browser::-webkit-scrollbar-thumb{\n    border-radius: 10px;\n    background-color: rgba(0, 0, 0, 0.3);\n}\n.edit-line-chart-widget-series-container .body table .series-key-container .series-keys-browser div{\n    padding: 10px 12px;\n    cursor: pointer;\n    white-space: nowrap;\n    box-sizing: border-box;\n    font-size: 14px;\n    overflow-x: hidden;\n    border-bottom: 1px solid rgb(216, 216, 216);\n    transition: background-color 0.25s ease;\n}\n.edit-line-chart-widget-series-container .body table .series-key-container .series-keys-browser div:hover{\n    background-color: rgb(236, 236, 236);\n}\n.edit-line-chart-widget-series-container .body table .series-key-container .series-keys-browser div span{\n    margin-right: 5px;\n    display: inline-block;\n    transform: rotate(-145deg);\n}\n.edit-line-chart-widget-series-container .body table .series-label-container{\n    box-sizing: border-box;\n}\n.edit-line-chart-widget-series-container .body table .series-label-container input{\n    width: 100%;\n    padding: 4px 10px;\n    outline: none;\n    border-radius: 4px;\n    box-sizing: border-box;\n    border: 1px solid rgb(216, 216, 216);\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n.edit-line-chart-widget-series-container .body table .series-max-value-container,\n.edit-line-chart-widget-series-container .body table .series-color-container,\n.edit-line-chart-widget-series-container .body table .series-units-container,\n.edit-line-chart-widget-series-container .body table .series-decimals-container{\n    position: relative;\n    box-sizing: border-box;\n}\n.edit-line-chart-widget-series-container .body table .series-max-value-container input{\n    width: 100%;\n    padding: 4px 10px;\n    border-radius: 4px;\n    outline: none;\n    box-sizing: border-box;\n    border: 1px solid rgb(216, 216, 216);\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n.edit-line-chart-widget-series-container .body table .series-color-container input{\n    width: 25px;\n    height: 25px;\n    margin: 0px;\n    padding: 0px;\n    border: none;\n    outline: none;\n    cursor: pointer;\n    box-sizing: border-box;\n    background-color: transparent;\n}\n.edit-line-chart-widget-series-container .body table  .series-units-container input{\n    width: 100%;\n    padding: 4px 8px;\n    border-radius: 4px;\n    outline: none;\n    box-sizing: border-box;\n    color: gray;\n    border: 1px solid rgb(216, 216, 216);\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n.edit-line-chart-widget-series-container .body table  .series-units-container .units-key-entry{\n    padding: 4px 8px;\n    padding-left: 10px;\n    font-size: 14px;\n    cursor: default;\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border: 1px solid rgb(216, 216, 216);\n}\n.edit-line-chart-widget-series-container .body table  .series-units-container .units-key-entry .remove-units{\n    cursor: pointer;\n    font-size: 13px;\n    color: rgb(104, 104, 104);\n}\n.edit-line-chart-widget-series-container .body table  .series-units-container .series-units-browser{\n    position: absolute;\n    z-index: 1;\n    top: 100%;\n    max-height: 22vh;\n    overflow-y: auto;\n    width: 200px;\n    left: 20px;\n    display: none;\n    margin-top: 0px;\n    box-sizing: border-box;\n    transform: translateX(-10px);\n    background-color: white;\n    box-shadow: 0px 0px 8px rgba(80, 80, 80, 0.4);\n    border-radius: 0px 0px 4px 4px;\n}\n.edit-line-chart-widget-series-container .body table  .series-units-container .series-units-browser.active{\n    display: block;\n}\n.edit-line-chart-widget-series-container .body table  .series-units-container .series-units-browser div{\n    display: flex;\n    justify-content: space-between;\n    padding: 10px 12px;\n    cursor: pointer;\n    white-space: nowrap;\n    box-sizing: border-box;\n    font-size: 13px;\n    overflow-x: hidden;\n    transition: background-color 0.25s ease;\n}\n.edit-line-chart-widget-series-container .body table  .series-units-container .series-units-browser div:hover{\n    background-color: rgb(236, 236, 236);\n}\n.edit-line-chart-widget-series-container .body table  .series-units-container .series-units-browser::-webkit-scrollbar{\n    width: 4px;\n}\n.edit-line-chart-widget-series-container .body table  .series-units-container .series-units-browser::-webkit-scrollbar-thumb{\n    border-radius: 10px;\n    background-color: rgba(0, 0, 0, 0.3);\n}\n.edit-line-chart-widget-series-container .body table .series-decimals-container input{\n    width: 100%;\n    padding: 4px 2px;\n    padding-left: 8px;\n    border-radius: 4px;\n    outline: none;\n    box-sizing: border-box;\n    border: 1px solid rgb(216, 216, 216);\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n.edit-line-chart-widget-series-container .body table .series-delete-container button{\n    border: none;\n    cursor: pointer;\n    background-color: transparent;\n}\n.edit-line-chart-widget-series-container .body table .series-delete-container button img{\n    height: 20px;\n}\n.edit-line-chart-widget-series-container .body table .empty-series-container h3{\n    margin: 20px 0px;\n    margin-bottom: 6px;\n    text-align: center;\n    font-weight: 400;\n    color: rgb(128, 128, 128);\n}\n.edit-line-chart-widget-series-container .body table .empty-series-container p{\n    margin: 0px;\n    color: red;\n    font-size: 12px;\n    text-align: center;\n    margin-bottom: 20px;\n}\n.edit-line-chart-widget-series-container .body .add-series-button{\n    margin-top: 10px;\n    padding: 8px 12px;\n    font-weight: 600;\n    border-radius: 4px;\n    cursor: pointer;\n    color: rgba(155, 30, 30, 0.952);\n    background-color: transparent;\n    border: 1px solid rgb(212, 212, 212);\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    transition: background-color 0.25s ease;\n}\n.edit-line-chart-widget-series-container .body .add-series-button:hover{\n    background-color: rgb(246, 246, 246);\n}\n.edit-line-chart-widget-series-container .empty-data-source-container h3{\n    margin: 20px 0px;\n    margin-bottom: 6px;\n    text-align: center;\n    font-weight: 400;\n    color: rgb(128, 128, 128);\n}\n.edit-line-chart-widget-series-container .empty-data-source-container p{\n    margin: 0px;\n    color: red;\n    font-size: 12px;\n    text-align: center;\n    margin-bottom: 20px;\n}\n/*End of series section*/\n\n/*Appearance section*/\n.edit-line-chart-widget-appearance-container{\n    padding: 25px;\n    border-radius: 4px;\n    margin-bottom: 15px;\n    box-shadow: 0px 0px 8px rgba(129, 129, 129, 0.15);\n}\n.edit-line-chart-widget-appearance-container h2{\n    margin: 0px;\n    font-size: 18px;\n    font-weight: 500;\n}\n.edit-line-chart-widget-appearance-container .title-container{\n    display: flex;\n    align-items: center;\n}\n.edit-line-chart-widget-appearance-container .body .title-entry-container{\n    position: relative;\n    width: 50%;\n    margin: 20px 0px;\n    padding: 4px 10px;\n    box-sizing: border-box;\n    background-color: rgba(222, 229, 233, 0.6);\n    border-bottom: 1px solid rgb(128, 128, 128);\n}\n.edit-line-chart-widget-appearance-container .body .title-entry-container:focus-within{\n    border-bottom: 1px solid rgba(155, 30, 30, 0.953);\n}\n.edit-line-chart-widget-appearance-container .body .title-entry-container p{\n    margin: 0px;\n    font-size: 12px;\n}\n.edit-line-chart-widget-appearance-container .body .title-entry-container input{\n    width: 100%;\n    border: none;\n    outline: none;\n    box-sizing: border-box;\n    background-color: transparent;\n}\n.edit-line-chart-widget-appearance-container .body .show-title-container{\n    padding-left: 25px;\n    display: flex;\n    align-items: center;\n}\n.edit-line-chart-widget-appearance-container .body .show-title-container p{\n    margin: 0px;\n}\n.edit-line-chart-widget-appearance-container .title-color-container{\n    position: relative;\n    margin: 20px 0px;\n    padding: 4px 10px;\n    box-sizing: border-box;\n    background-color: rgba(222, 229, 233, 0.6);\n    border-bottom: 1px solid rgb(128, 128, 128);\n}\n.edit-line-chart-widget-appearance-container .title-color-container:focus-within{\n    border-bottom: 1px solid rgba(155, 30, 30, 0.952);\n}\n.edit-line-chart-widget-appearance-container .title-color-container p{\n    margin: 0px;\n    font-size: 12px;\n    color: rgb(88, 88, 88);\n}\n.edit-line-chart-widget-appearance-container .title-color-container div{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n.edit-line-chart-widget-appearance-container .title-color-container div p{\n    font-size: 14px;\n    color: rgb(26, 26, 26);\n}\n.edit-line-chart-widget-appearance-container .title-color-container div input{\n    width: 25px;\n    height: 25px;\n    margin: 0px;\n    padding: 0px;\n    border: none;\n    outline: none;\n    cursor: pointer;\n    box-sizing: border-box;\n}\n.edit-line-chart-widget-appearance-container .border-radius-container,\n.edit-line-chart-widget-appearance-container .mobile-height-container{\n    position: relative;\n    margin: 20px 0px;\n    padding: 4px 10px;\n    box-sizing: border-box;\n    background-color: rgba(222, 229, 233, 0.6);\n    border-bottom: 1px solid rgb(128, 128, 128);\n}\n.edit-line-chart-widget-appearance-container .border-radius-container:focus-within,\n.edit-line-chart-widget-appearance-container .mobile-height-container:focus-within{\n    border-bottom: 1px solid rgba(155, 30, 30, 0.952);\n}\n.edit-line-chart-widget-appearance-container .border-radius-container p,\n.edit-line-chart-widget-appearance-container .mobile-height-container p{\n    margin: 0px;\n    font-size: 12px;\n    color: rgb(88, 88, 88);\n}\n.edit-line-chart-widget-appearance-container .border-radius-container div,\n.edit-line-chart-widget-appearance-container .mobile-height-container div{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n.edit-line-chart-widget-appearance-container .border-radius-container div p,\n.edit-line-chart-widget-appearance-container .mobile-height-container div p{\n    font-size: 14px;\n    color: rgb(26, 26, 26);\n}\n.edit-line-chart-widget-appearance-container .border-radius-container div input,\n.edit-line-chart-widget-appearance-container .mobile-height-container div input{\n    width: 25%;\n    cursor: pointer;\n}\n/*End of appearance section*/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
